import React, {useEffect, useState} from 'react';
import {connect} from 'react-redux';
import Dialog from '@material-ui/core/Dialog';
import MuiDialogTitle from '@material-ui/core/DialogTitle/DialogTitle';
import MuiDialogContent from '@material-ui/core/DialogContent/DialogContent';
import MuiDialogActions from '@material-ui/core/DialogActions';
import Typography from '@material-ui/core/Typography';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import {withStyles, Button, CircularProgress} from '@material-ui/core';
import {getProfile} from '../../../../../redux/actions/User/Profile/profileAction';
import {manualPaymentAudit, clearManualPaymentAudit} from '../../../../../redux/actions/Payment/ManualPaymentCancel/manualPaymentCancelActions';
import {c, AuditTransactionList} from './paymentAuditShared';

const ALLOWED_EMAILS = [
    'cemile@extranetwork.com',
    'bulut@extranetwork.com',
    'yoy@extranetwork.com',
    'onur@extranetwork.com',
    'cem@extranetwork.com',
    'partnerships@extranetwork.com',
    'zehra@extranetwork.com'
];

const titleStyles = theme => ({
    root: {margin: 0, padding: theme.spacing(2, 3)},
    closeButton: {position: 'absolute', right: theme.spacing(1.5), top: theme.spacing(1.5), color: theme.palette.grey[500]},
});

const DialogTitle = withStyles(titleStyles)(props => {
    const {children, classes, onClose, ...other} = props;
    return (
        <MuiDialogTitle disableTypography className={classes.root} {...other}>
            <Typography variant="h6" style={{fontWeight: 700}}>{children}</Typography>
            {onClose ? (
                <IconButton aria-label="close" className={classes.closeButton} onClick={onClose}>
                    <CloseIcon className="close-button"/>
                </IconButton>
            ) : null}
        </MuiDialogTitle>
    );
});

const DialogContent = withStyles(theme => ({
    root: {padding: theme.spacing(3), background: '#fbfcfe'},
}))(MuiDialogContent);

const DialogActions = withStyles(theme => ({
    root: {margin: 0, padding: theme.spacing(2, 3), borderTop: `1px solid ${c.line}`},
}))(MuiDialogActions);

function AuditReportModal({
    manualTransactionList,
    userEmail,
    getProfile,
    manualPaymentAudit,
    clearManualPaymentAudit,
    auditFetching,
    auditData,
}) {
    const [open, setOpen] = useState(false);

    useEffect(() => {
        if (!userEmail && typeof getProfile === 'function') {
            getProfile();
        }
    }, [userEmail, getProfile]);

    const orderId = manualTransactionList && manualTransactionList.order_id;

    const loadAudit = () => {
        if (typeof manualPaymentAudit === 'function' && orderId) {
            manualPaymentAudit({order_id: orderId});
        }
    };

    const handleOpen = () => {
        setOpen(true);
        loadAudit();
    };

    const handleClose = () => {
        setOpen(false);
        clearManualPaymentAudit();
    };

    // Yetki: sadece allowlist'teki e-postalar butonu görür
    if (!userEmail || !ALLOWED_EMAILS.includes(userEmail.toLowerCase())) {
        return null;
    }

    const auditTransactions = (auditData && auditData.data && Array.isArray(auditData.data.transactions))
        ? auditData.data.transactions : [];

    return (
        <>
            <a
                href="#/"
                onClick={(e) => { e.preventDefault(); handleOpen(); }}
                className="filter-action-button float-right mb-24"
                style={{marginRight: 12, backgroundColor: '#334155', borderColor: '#334155'}}
            >
                <i style={{marginRight: "2px"}} className="fas fa-file-invoice"/> Audit Raporu
            </a>

            <Dialog
                onClose={handleClose}
                open={open}
                maxWidth="md"
                fullWidth
                aria-labelledby="audit-report-title"
            >
                <DialogTitle className="red-bottom-border" id="audit-report-title" onClose={handleClose}>
                    Audit Raporu
                    <span style={{marginLeft: 10, fontSize: 13, fontWeight: 600, color: c.sub}}>{orderId || ''}</span>
                </DialogTitle>

                <DialogContent>
                    <div style={{
                        display: 'flex', gap: 10, alignItems: 'flex-start',
                        background: '#f1f5f9', border: '1px solid #e2e8f0', borderRadius: 10,
                        padding: '12px 14px', marginBottom: 20,
                    }}>
                        <i className="fas fa-info-circle" style={{color: '#475569', marginTop: 2}}/>
                        <span style={{fontSize: 13, color: '#334155', lineHeight: 1.5}}>
                            Bu siparişteki <strong>tüm işlemlerin</strong> tam geçmişi (kim oluşturdu, kim güncelledi/iptal etti,
                            eski → yeni durum ve tutar). Salt-okunur.
                        </span>
                    </div>

                    <div style={{display: 'flex', justifyContent: 'flex-end', marginBottom: 12}}>
                        <Button size="small" onClick={loadAudit} disabled={auditFetching} startIcon={!auditFetching && <i className="fas fa-sync-alt" style={{fontSize: 12}}/>} style={{textTransform: 'none'}}>
                            {auditFetching ? <CircularProgress size={16}/> : 'Yenile'}
                        </Button>
                    </div>

                    <AuditTransactionList
                        transactions={auditTransactions}
                        loading={auditFetching}
                        emptyText="Kayıt bulunamadı."
                    />
                </DialogContent>

                <DialogActions>
                    <Button onClick={handleClose} style={{textTransform: 'none', fontWeight: 600, height: 42}}>
                        Kapat
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    );
}

const mapStateToProps = (state) => ({
    userEmail: state.profileReducer && state.profileReducer.profileData
        && state.profileReducer.profileData.profile
        && state.profileReducer.profileData.profile.email,
    auditFetching: state.manualPaymentCancelReducer && state.manualPaymentCancelReducer.auditFetching,
    auditData: state.manualPaymentCancelReducer && state.manualPaymentCancelReducer.auditData,
});

const mapDispatchToProps = {
    getProfile,
    manualPaymentAudit,
    clearManualPaymentAudit,
};

export default connect(mapStateToProps, mapDispatchToProps)(AuditReportModal);
